import React, { useState } from "react";

import DatePicker from "react-multi-date-picker"
import persian from "react-date-object/calendars/persian"
import persian_fa from "react-date-object/locales/persian_fa"
import opacity from "react-element-popper/animations/opacity"
// import "react-color-palette/lib/css/styles.css";

// styles 
import Dstyles from "../AddNewFile.module.css"

const AddNewFileDatePicker = () => {
    const [value, setValue] = useState()
    const [openMenu, setOpenMenu] = useState(false);

    const handleChange = async (value) => {
        //تغییرات روی تاریخ رو اینجا اعمال کنید
        setValue(value)
        if (openMenu === true) {
            setOpenMenu(false)
        }
        // const userDate = `${value.year}-${value.month.number}-${value.day}`
        // console.log(userDate)
        // const userDate = await `${value.year}-${value.month.number}-${value.day} ${value.hour}:${value.minute}:${value.second}`
    }
    
    return (
        <>
            <style type="text/css">
                {`
                .rmdp-container {
                    width: 295px;
                    height: 48px !important;
                    background: #F9F9F9;
                    border: 1px solid #E1E1E1;
                    border-radius: 24px;
                    display: flex !important;
                    align-items: center;
                    justify-content: start;
                    padding-right: 27px;
                    cursor: pointer;
    }
    
                .rmdp-wrapper {
                    width: 295px;
                    background: #F9F9F9 !important;
                    border: 1px solid #E1E1E1 !important;
                    border-radius: 24px !important;
                    box-shadow: none !important;
                    display: flex;
                    align-items: center;
                    justify-content: center;
        }
    `}
            </style>
            <div className="py-2">
                <div className="container-fluid">
                    <div
                        className="d-flex justify-content-md-between justify-content-center flex-wrap align-items-center mt-3 me-3"
                        dir="rtl"
                    >
                        <div className="d-flex align-items-start justify-content-center flex-column">
                            <div className={`mb-2 ${Dstyles.submenu_title}`}>
                                تاریخ اتمام ساخت
                            </div>
                            {/* <DatePicker
                                value={value}
                                // value="انتخاب تاریخ اتمام"
                                onChange={handleChange}
                                calendar={persian}
                                calendarPosition="bottom-center"
                                locale={persian_fa}
                            /> */}
                            <DatePicker
                                value={value}
                                onChange={handleChange}
                                animations={[opacity()]}
                                render={(value, openCalendar) => {
                                    return (
                                        <div onClick={openCalendar}>
                                            {value
                                                ?
                                                ""
                                                :
                                                <div className={Dstyles.date_submenu_text}>
                                                    انتخاب تاریخ اتمام
                                                </div>
                                            }
                                            {value}
                                        </div>
                                    )
                                }}
                                calendar={persian}
                                locale={persian_fa}
                                calendarPosition="bottom-center"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default AddNewFileDatePicker;